const constants = {
  DEFAULT_URL:
    process.env.REACT_APP_API_URL || "https://demo-api.polismall.com",

  HTTP_STATUS_SUCCESS: 200,
  HTTP_STATUS_UNAUTHORIZED: 403,
  HTTP_STATUS_FAILED: 401,
  HTTP_STATUS_ERROR: 400,
};

export default constants;
